import * as React from 'react';
import {Container, Text} from '@inlet/react-pixi';
import {Rectangle, Triangle} from '@gongxigames/framework/core/fragments/react';
import { DisplayObjectList } from './DisplayObjectList';
import { ScrollComponent } from './ScrollContainer';
import {TextStyle} from 'pixi.js';

const style = new TextStyle({
    fontFamily: 'Arial',
    fontSize: 80,
    fontWeight: 'bold',
    align: 'center',
    fill: '#000000'
});

 type SelectProps = {
     width: number;
     options: string[];
     selectLength?: number;
     value?: string;
     onChange: (value: string) => void;
     placeholder?: string;
     zIndex?: number;
};

type SelectState = {
     optionVisible: boolean;
};

export class Select extends React.Component<SelectProps, SelectState> {
    public state: SelectState = {
        optionVisible: false
    };

    protected toggleOptionVisible(): void {
        this.setState(state => {
            return {optionVisible: !state.optionVisible};
        });
    }

    protected onSelect(value: string): void {
        if (value !== this.props.value) {
            this.props.onChange(value);
        }

        this.setState({optionVisible: false});
    }

    protected getOption(value: string, height: number): JSX.Element {
        const selected = value === this.props.value;
        const fill = selected ? 0xddddff : 0xdddddd;

        return (
            <Container key={value} interactive={true} buttonMode={true} pointertap={() => this.onSelect(value)}>
                <Rectangle width={this.props.width} height={height} fill={fill} border={{color: 0x000000, width: 2}}/>
                <Text interactive={true} buttonMode={true} x={12} y={height / 2} text={value} anchor={[0, 0.5]} style={style}/>
            </Container>
        );
    }

    public render(): JSX.Element {
        const {width, options, placeholder = 'Select...', zIndex, selectLength = 5} = this.props;
        const value = this.props.value || placeholder;
        const height = 100;
        const triangleWidth = 50;
        const leftRightPadding = 12;
        const optionHeight = (height + leftRightPadding) * Math.min(options.length, selectLength);

        return (
            <Container x={10} zIndex={zIndex}>
                <Container interactive={true} buttonMode={true} pointertap={this.toggleOptionVisible.bind(this)}>
                    <Rectangle width={width} height={height} fill={0xdddddd}/>
                    <Text x={leftRightPadding} y={height / 2} text={value} anchor={[0, 0.5]} style={style}/>
                    <Triangle x={width - (triangleWidth + leftRightPadding)}
                        y={(height / 2) - triangleWidth / 2} width={triangleWidth} fill={0x888888}
                    />
                </Container>
                <Container y={height} visible={this.state.optionVisible} >
                    <Rectangle width={width} height={optionHeight + leftRightPadding} fill={0xdddddd} alpha={0.8}/>
                    <ScrollComponent y={leftRightPadding} boundsWidth={width} boundsHeight={optionHeight} >
                        <DisplayObjectList gapBetweenChildren={10} direction={'column'} >
                            {options.map(option => this.getOption(option, height))}
                        </DisplayObjectList>
                    </ScrollComponent>
                </Container>
            </Container>
        );
    }
}
